<template>
  <v-autocomplete
    ref="userAutocomplete"
    v-model="selectedUsers"
    :items="allowedUsers"
    :menu-props="{offsetY: true, offsetOverflow: true, transition: false}"
    :multiple="multiple"
    :search-input.sync="searchInput"
    v-bind="$attrs"
  >
    <template #selection="data">
      <slot
        name="selection"
        v-bind="data"
      >
        <template v-if="multiple">
          <v-chip
            close
            :disabled="isDisabled"
            :input-value="data.selected"
            v-bind="data.attrs"
            @click:close="removeUser(data.item)"
          >
            {{ data.item.displayName }}
          </v-chip>
        </template>
        <template v-else>
          {{ data.item.displayName }}
        </template>
      </slot>
    </template>
    <template #item="{ item }">
      <slot name="item">
        <UserSelectListItem :user="item" />
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import UserSelectListItem from './UserSelectListItem.vue'

export default {
  name: 'UserSelectAutocomplete',
  components: { UserSelectListItem },
  inheritAttrs: false,

  model: {
    prop: 'users',
    event: 'change',
  },

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },

    userList: {
      type: Array,
      required: true,
    },

    users: {
      type: [Array, Number],
      required: true,
    },
  },

  data () {
    return {
      lazyUsers: undefined,
      searchInput: '',
      userAutocompleteRef: null,
    }
  },

  computed: {
    allowedUsers () {
      return this.userList
    },

    isDisabled () {
      return this.userAutocompleteRef?.isDisabled
    },

    selectedUsers: {
      get () {
        return this.lazyUsers
      },

      set (value, oldValue) {
        if (value === oldValue) return

        this.lazyUsers = value
        this.searchInput = ''
        this.$emit('change', value)
      },
    },
  },

  watch: {
    users (value) {
      this.lazyUsers = value
    },
  },

  mounted () {
    this.$set(this.$data, 'userAutocompleteRef', this.$refs.userAutocomplete)
  },

  created () {
    this.lazyUsers = this.users
  },

  methods: {
    focus () {
      this.$refs.userAutocomplete.focus()
    },

    removeUser (user) {
      if (!Array.isArray(this.lazyUsers)) { return }
      const idx = this.lazyUsers.findIndex(u => u === user.value)
      if (idx >= 0) { this.selectedUsers.splice(idx, 1) }
    },

    validate () {
      this.userAutocompleteRef?.validate()
    },
  },
}
</script>
